<template>
    <div class='VuePagination' :class='props.theme.wrapper'>
        <div class="VuePagination__count">
            <span id="filter-bar-total--bottom">- </span>  ervaringen
        </div>

        <nav class='VuePagination__nav'>

            <ul v-show="props.showPagination" :class="props.theme.list">

<!--                <li :class="props.theme.prev" @click="props.setPrevPage">-->
<!--                    <a class="button button&#45;&#45;blue" rel="prev" v-bind="{...props.aProps,...props.prevProps}">Vorige</a>-->
<!--                </li>-->

                <li v-for="page in props.pages" :key="page" :class="props.pageClasses(page)"
                    v-on="props.pageEvents(page)">
                    <button :data-href="createHrefForSeo(page)" v-bind="props.aProps" :class="props.theme.link">{{page}}</button>
                </li>

                <li :class="props.theme.next" @click="props.setNextPage">
                    <a class="button button--blue" rel="next" v-bind="{...props.aProps, ...props.nextProps}">Volgende</a>
                </li>
            </ul>

        </nav>
    </div>

</template>

<script>
    export default {
        name: 'MyPagination',
        props: ['props'],
        data () {
            return {
                fullUrl: ''
            }
        },
        created() {
            this.createHrefForSeo()
        },
        methods: {
            createHrefForSeo(page) {
                let fullUrl = window.location.href;
                if (page === 1) {
                    fullUrl = this.removeParam('page', fullUrl);
                    return fullUrl;
                }
                if (fullUrl.includes('page')) {
                    fullUrl = this.removeParam('page', fullUrl);
                }
                if (!fullUrl.includes('?')) {
                    fullUrl = fullUrl + '?page=' + page;
                } else {
                    fullUrl = fullUrl + '&page=' + page;
                }

                return fullUrl;
            },
            removeParam(key, sourceURL) {
                var rtn = sourceURL,
                    param,
                    params_arr = [],
                    queryString = sourceURL;
                if (queryString !== "") {
                    params_arr = queryString.split("&");
                    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                        param = params_arr[i].split("=")[0];
                        if (param === key) {
                            params_arr.splice(i, 1);
                        }
                    }
                    if (params_arr.length) rtn = params_arr.join("&");
                }
                return rtn;
            }
        }
    }
</script>
